import {
    Box, Tooltip
} from '@chakra-ui/react';
import React from 'react';

import {
    BadgeDescription,
    BadgeHeader,
    BadgeItem,
    BadgeSvg,
    NewBadge,
    BadgeSvgContainer,
    getBadgeHeaderStyles,
    getBadgeItemStyles,
    getBadgeDescriptionStyles,
    getBadgeImageSrc
} from './landing-badge.styled';
import {
    TeacherAdminIcon, TeacherAdminIcons
} from '@components';

export enum LandingBadgeVariants {
    default,
    new
}

type LandingBadgeProps = {
    id: number
    name: string
    description: string
    icon: TeacherAdminIcons
    onLandingBadgeOpen: () => void
    tooltip: string
    variant: LandingBadgeVariants
    locale: string
};

export const LandingBadge = ({
    id,
    name,
    description,
    icon,
    onLandingBadgeOpen,
    tooltip,
    variant = LandingBadgeVariants.default,
    locale
}: LandingBadgeProps) => {
    return (
        <Tooltip
            label={tooltip}
            placement={'bottom'}
            openDelay={800}
            hasArrow={true}
        >
            <BadgeItem
                {...getBadgeItemStyles(variant)}
                key={id}
                onClick={onLandingBadgeOpen}
                data-testid={`${id}-landing-badge-test`}
            >
                <BadgeSvgContainer>
                    <BadgeSvg>
                        <TeacherAdminIcon
                            icon={icon}
                            width={30}
                        />
                    </BadgeSvg>
                </BadgeSvgContainer>
                <Box>
                    <BadgeHeader {...getBadgeHeaderStyles(variant)}>
                        {name}
                    </BadgeHeader>
                    <BadgeDescription {...getBadgeDescriptionStyles(variant)}>
                        {description}
                    </BadgeDescription>
                </Box>
                {variant === LandingBadgeVariants.new ? <NewBadge src={getBadgeImageSrc(variant, locale)} /> : null}
            </BadgeItem>
        </Tooltip>
    );
};
